enum Store {
  DMP2Core = 'DMP2Core',
  FordOffLease = 'FordOffLease',
  LightAccident = '148pt',
  Manheim = 'Manheim',
  PartnerRetail = 'Partner-Retail'
}

export default Store;
